import Golferz from "./media/golferz.gif"

export default function GolferzGif({width}) {
    return(<img src={Golferz} width={width ? width : "100%"} alt="Golferz"/>)
}